import { Injectable } from '@angular/core';
import { TaskHeaderLayoutType } from '@Core/models/proprietary/task/task-object.types';
import { LocalStorage } from '@Core/services/proprietary/browser-storage/local-storage.service';
import { MenuLayoutType, MenuPositionType } from '@Core/services/proprietary/menu.types';

//This class is used to store global shared variables -- DO NOT INJECT OTHER SERVICES INTO THIS SERVICE

//TODO:  Move other globals from App.Service to this service.
//TODO:  User Settings are temporarily managed here under model.UserPref -- this will be changed in the future to be more generalized by page.  
// This is quick and dirty for now!!!

@Injectable()
export class AppConfigService {
    private model = {
        Config: {
            allowDataCache: true,
            defaultCacheLifeSpan: '30',
            allowClientDebug: false
        },
        UserPref: {
            Menu_Position: MenuPositionType.Top,
            Menu_Layout: MenuLayoutType.TileBig,
            Recent_Item_Layout: 'card',
            Favorite_Layout: 'card',
            Paginate_Items_Per_Page: '50',
            Task_Header_Default_Layout: TaskHeaderLayoutType.Normal,
            Task_Header_Task_Desc_Lines: 0,
            DocPanel_Width: 500,
            DocPanel_DetailPanelOpen: 'false',
            DocPanel_DetailPanelWidth: 200
        }
    };

    private defaultUserPref = {
        Menu_Position: MenuPositionType.Top,
        Menu_Layout: MenuLayoutType.TileBig,
        Recent_Item_Layout: 'card',
        Favorite_Layout: 'card',
        Paginate_Items_Per_Page: '50',
        Task_Header_Default_Layout: TaskHeaderLayoutType.Normal,
        Task_Header_Task_Desc_Lines: 0,
        DocPanel_Width: 500,
        DocPanel_DetailPanelOpen: 'false',
        DocPanel_DetailPanelWidth: 200
    };

    constructor(private localStorage: LocalStorage) { }

    //Property: allowDataCache
    get allowDataCache(): any {
        return this.model.Config.allowDataCache;
    }

    set allowDataCache(allowed: boolean) {
        this.model.Config.allowDataCache = allowed;
    }

    //Property: defaultCacheLifeSpan
    get defaultCacheLifeSpan(): any {
        return this.model.Config.defaultCacheLifeSpan;
    }

    set defaultCacheLifeSpan(value: any) {
        this.model.Config.defaultCacheLifeSpan = value;
    }

    //Property: allowClientDebug
    get allowClientDebug() {
        return this.model.Config.allowClientDebug;
    }

    set allowClientDebug(allowed: boolean) {
        this.model.Config.allowClientDebug = allowed;
    }

    //functions to get or set an individual user preference
    getUserPref(pref: string, defaultValue?: any) {
        const value = this.model.UserPref[pref];

        if (value.toString() !== 'undefined') {
            return value;
        } else {
            if (defaultValue) {
                return defaultValue;
            }
            if (pref in this.defaultUserPref) {
                return this.defaultUserPref[pref];
            }
        }
    }

    setUserPref(pref: string, value: any): Promise<void> {
        return new Promise<void>((resolve) => {
            this.model.UserPref[pref] = value;
            this.saveUserPreferences();
            resolve();
        });
    }

    saveUserPreferences() {
        let userPreferences = {
            ...this.model.UserPref
        };
        let stringifiedPref = JSON.stringify(userPreferences);
        this.localStorage.setItem('preference:user', stringifiedPref);
    }

    async loadUserPreferences() {
        return new Promise<boolean>(async (resolve) => {
            let prefString = this.localStorage.getItem('preference:user');
            if (prefString) {
                let prefObject = JSON.parse(prefString);
                const userPrefKeys = Object.keys(prefObject);
                for (const key of userPrefKeys) {
                    this.model.UserPref[key] = prefObject[key];
                }
                resolve(true);
            } else {
                resolve(false);
            }
        });
    }
}
